'use client'

import { Label, Divider, Cell, Card } from '@vinted/web-ui'

import { FormattedMessage } from '@marketplace-web/shared/i18n'

import { SeparatedList } from '@marketplace-web/common-components/separated-list-ui'

import CountrySelect from './CountrySelect'
import CitySelect from './CitySelect'
import CityVisibilityToggle from './CityVisibilityToggle'

const Location = () => {
  return (
    <>
      <Label text={<FormattedMessage id="profile_settings.location.title" />} />
      <Card>
        <Cell styling={Cell.Styling.Tight}>
          <SeparatedList separator={<Divider />}>
            <CountrySelect />
            <CitySelect />
            <CityVisibilityToggle />
          </SeparatedList>
        </Cell>
      </Card>
    </>
  )
}

export default Location
